<script setup>
import { VideoBlockLayout } from '~~/types/enums'

const props = defineProps(['model'])

const titleFor = useVideoIframeTitle()
const videoSrc = computed(() => props.model?.youTubeURL?.value || props.model?.vimeoURL?.value)
const iframeTitle = computed(() => titleFor([props.model?.blockTitle?.value], videoSrc.value))
</script>

<template>
  <div
    class="video-block block-spacing"
    :class="{ 'video-block--split': model?.layout?.value === VideoBlockLayout.Split }"
  >
    <div class="container-fluid">
      <div
        class="video-block__content-wrap m-auto"
        :class="{ 'lg:flex lg:gap-[30px] lg:items-start': model?.layout?.value === VideoBlockLayout.Split }"
      >
        <BlockHeader
          v-if="model?.blockTitle?.value || model?.blockBody?.value"
          :title="model?.blockTitle?.value"
          :summary="model?.blockBody?.value"
        />
        <div
          class="video-block__video-wrap w-full"
          :class="{ 'lg:max-w-[62.5%] lg:shrink-0': model?.layout?.value === VideoBlockLayout.Split }"
        >
          <iframe
            v-if="videoSrc"
            :title="iframeTitle"
            :src="videoSrc"
            allow="autoplay; encrypted-media"
            allowfullscreen
            class="aspect-video w-full video-block__video rounded-xl border-0"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "@/assets/css/blocks/video-block.scss";
</style>
